import { render, staticRenderFns } from "./ChangeAffinity.vue?vue&type=template&id=b6bcbc70&scoped=true&"
import script from "./ChangeAffinity.vue?vue&type=script&lang=js&"
export * from "./ChangeAffinity.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAffinity.vue?vue&type=style&index=0&id=b6bcbc70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bcbc70",
  null
  
)

export default component.exports